export default "__VITE_ASSET__D0i8gVCe__"